import request from '../helpers/request';

const changeRequestCreationMethod = async ({ requestId, methodId }) => {
  return await request.put(
    `/Request/creation_method/${requestId}`,
    methodId,
    'Не удалось поменять метод создания заявки'
  );
};

export default changeRequestCreationMethod;
